<template>
  <v-dialog v-model="dialogVisible" max-width="500px" persistent>
    <v-card>
      <v-toolbar class="toolbar-color">
        <v-toolbar-title class="text-white"
          ><v-icon color="white" size="20" class="mr-2">mdi-pencil</v-icon
          >Change Team Status</v-toolbar-title
        >

        <v-btn icon elevation="0" @click="closeDialog">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form ref="form" @submit.prevent="saveTeamStatus">
          <div class="mb-6">
            <h3 class="text-h6 mb-2">{{ editingTeam.organization_name }}</h3>
            <p class="text-body-2 text-grey-darken-1">
              {{ editingTeam.organization_created_by }}
            </p>
          </div>

          <v-select
            v-model="status"
            :items="statusOptions"
            label="Change Status"
            required
            variant="outlined"
            :rules="[(v) => !!v || 'Status is required']"
            class="mb-4"
          />
        </v-form>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-btn
          color="primary"
          @click="saveTeamStatus"
          :loading="saving"
          :disabled="!status"
        >
          Save Changes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { generateClient } from "aws-amplify/api";
import { update_organization_type } from "@/graphql/mutations.js";

const client = generateClient();

export default {
  name: "EditTeamDialog",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    team: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      editingTeam: {},
      status: "",
      saving: false,
      statusOptions: ["LIVE", "PROSPECT"],
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue(newVal) {
      if (newVal && this.team) {
        this.editingTeam = { ...this.team };
        this.status = this.editingTeam.organization_type;
      }
    },
  },
  methods: {
    async saveTeamStatus() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.saving = true;
      try {
        // Call the update organization type API
        const result = await client.graphql({
          query: update_organization_type,
          variables: {
            input: {
              organization_id: this.editingTeam.organization_id,
              organization_type: this.status,
            },
          },
        });

        // console.log('Update result:', result)

        if (result.data.update_organization_type) {
          // Emit success event
          this.$emit("team-updated", this.editingTeam);

          // Show success notification
          this.$store.dispatch("setNotification", {
            type: "success",
            message: "Team status updated successfully!",
          });

          // Close dialog
          this.closeDialog();
        } else {
          throw new Error("Failed to update organization type");
        }
      } catch (error) {
        console.error("Error updating team status:", error);
        this.$store.dispatch("setNotification", {
          type: "error",
          message: "Failed to update team status. Please try again.",
        });
      } finally {
        this.saving = false;
      }
    },

    closeDialog() {
      this.dialogVisible = false;
      this.editingTeam = {};
      this.$refs.form?.resetValidation();
    },
  },
};
</script>

<style scoped>
.toolbar-color {
  background: linear-gradient(135deg, #3f78e0 0%, #da4c77 100%) !important;
}
.v-card-title {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  padding: 20px 24px;
}

.v-card-actions {
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

.v-btn {
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
}
</style>
